import { useMemo } from 'react';
import { DeviceProvider as SeagullDeviceProvider, useDevice } from 'seagull';
import { useFeatureFlags } from "../hooks/useFeatureFlags";
import { jsx as _jsx } from "react/jsx-runtime";
export function DeviceProvider(_ref) {
  let {
    children,
    isMobileDevice
  } = _ref;
  const value = useMemo(() => ({
    isMobileDevice
  }), [isMobileDevice]);
  return /*#__PURE__*/_jsx(SeagullDeviceProvider, {
    value: value,
    children: children
  });
}
export function useMobileResponsiveness() {
  const {
    MOBILE_RESPONSIVENESS = false
  } = useFeatureFlags();
  const {
    isMobileDevice
  } = useDevice();
  return useMemo(() => ({
    isMobileDevice: MOBILE_RESPONSIVENESS && isMobileDevice
  }), [MOBILE_RESPONSIVENESS, isMobileDevice]);
}